/* RESPONSIBLE TEAM: team-inbox-management */

import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';
import type Session from 'embercom/services/session';
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';
import { hash } from 'rsvp';

export default class MultilingualRoute extends SettingsRoute {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare store: any;
  @service declare session: Session;

  analytics = {
    section: 'settings',
    place: 'personal.multilingual',
  };

  get titleToken() {
    return this.intl.t('new-settings.submenu.personal.multilingual');
  }

  get app() {
    return this.appService.app;
  }

  async model() {
    try {
      return hash({
        generalSettings: this.store.findRecord('general-app-settings', this.appService.app?.id),
        messengerSettings: this.store.findRecord('messenger-settings/all', this.appService.app?.id),
        languages: this.store.findRecord('messenger-settings/languages', this.appService.app?.id),
        adminTeammateAppSettings: this.loadAdminTeammateAppSettings(),
      });
    } catch (e) {
      return {
        generalSettings: {},
        messengerSettings: {},
        languages: null,
        adminTeammateAppSettings: {},
      };
    }
  }

  async loadAdminTeammateAppSettings() {
    if (!this.session.teammate?.id) {
      return null;
    }

    try {
      return await this.store.findRecord('admin-teammate-app-settings', this.session.teammate.id, {
        reload: true,
      });
    } catch (error) {
      // Create new record if it doesn't exist
      return this.store.createRecord('admin-teammate-app-settings', {
        id: this.session.teammate.id,
      });
    }
  }
}
